'use strict';

import React from 'react';
import products from 'ck-core/source/data/products';
import PaymentPlansForProduct from './PaymentPlansForProduct.jsx';

export default class MinecraftPaymentPlans extends React.Component {
	render() {
		return <PaymentPlansForProduct product={products.MINECRAFT} />;
	}
}
